export default "__VITE_ASSET__6f9c01f4__"